import * as types from '../types'

// get user from localStorage
const initialState = {
    loading: false,
    logs: [],
    log: {},
    error: null
}

export const logReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_LOGS:
            return {
                ...state,
                logs: action.payload,
                loading: false,
                error: null
            }
        case types.SET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
        case types.RESET_LOADING:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.RESET:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}